export const ABOUT_CONSTS = {
    GET_ABOUT: "GET_ABOUT",
    UPDATE_ABOUT: "UPDATE_ABOUT",
    CREATE_ABOUT_BLOCK: "CREATE_ABOUT_BLOCK",
    GET_ABOUT_BLOCK_BY_ID: "GET_ABOUT_BLOCK_BY_ID",
    UPDATE_ABOUT_BLOCK_BY_ID: "UPDATE_ABOUT_BLOCK_BY_ID",
    DELETE_ABOUT_BLOCK_BY_ID: "DELETE_ABOUT_BLOCK_BY_ID",
};
